import type { CouponContentResponse } from '../../../../types/front.graphql';

export const sortCoupons = (coupons: CouponContentResponse[]) =>
    [...coupons].sort((a, b) => Number(a.is_in_wallet) - Number(b.is_in_wallet));
